// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.7.0
//   protoc               unknown
// source: fight/model/enums/FightSportPt.proto

/* eslint-disable */

export const protobufPackage = "io.teamsillim.fightbracket.idl.fight.model";

/** 격투기 종목 (종목마다 체급표가 다르다 — enums/*WeightClassPt.proto 와 1:1 로 짝지어진다) */
export enum FightSportPayload {
  FIGHT_SPORT_UNKNOWN = 0,
  /** AMATEUR_BOXING - 아마추어복싱 (WBC 아마추어복싱 · KBF 대한복싱연맹) */
  AMATEUR_BOXING = 1,
  /** IMMAF_MMA - IMMAF 종합격투기 (아마추어 MMA, 2024년 6월 개정 기준) */
  IMMAF_MMA = 2,
  /** MUAY_THAI_KICKBOXING - 무에타이 · 킥복싱 (두 종목에 동일 체급을 적용한다) */
  MUAY_THAI_KICKBOXING = 3,
  /** PRO_MMA - 프로 MMA (KMMAF · ALLFC, UFC 체급 기준) */
  PRO_MMA = 4,
  /** CHICKEN_FIGHT - 닭싸움 (국제닭싸움연맹, 전 부문 ABSOLUTE 무체급) */
  CHICKEN_FIGHT = 5,
  /** MUAY_THAI_KICKBOXING_NO_FACE - 무에타이 · 킥복싱(안면타격 X) — 안면타격만 빼고 무에타이 · 킥복싱과 같은 체급표를 쓴다 */
  MUAY_THAI_KICKBOXING_NO_FACE = 6,
  /** NO_GI_JIU_JITSU - 노기 주짓수 (-25kg ~ +90kg 15체급, 전 부 · 남녀 공통) */
  NO_GI_JIU_JITSU = 7,
  UNRECOGNIZED = -1,
}

export function fightSportPayloadFromJSON(object: any): FightSportPayload {
  switch (object) {
    case 0:
    case "FIGHT_SPORT_UNKNOWN":
      return FightSportPayload.FIGHT_SPORT_UNKNOWN;
    case 1:
    case "AMATEUR_BOXING":
      return FightSportPayload.AMATEUR_BOXING;
    case 2:
    case "IMMAF_MMA":
      return FightSportPayload.IMMAF_MMA;
    case 3:
    case "MUAY_THAI_KICKBOXING":
      return FightSportPayload.MUAY_THAI_KICKBOXING;
    case 4:
    case "PRO_MMA":
      return FightSportPayload.PRO_MMA;
    case 5:
    case "CHICKEN_FIGHT":
      return FightSportPayload.CHICKEN_FIGHT;
    case 6:
    case "MUAY_THAI_KICKBOXING_NO_FACE":
      return FightSportPayload.MUAY_THAI_KICKBOXING_NO_FACE;
    case 7:
    case "NO_GI_JIU_JITSU":
      return FightSportPayload.NO_GI_JIU_JITSU;
    case -1:
    case "UNRECOGNIZED":
    default:
      return FightSportPayload.UNRECOGNIZED;
  }
}

export function fightSportPayloadToJSON(object: FightSportPayload): string {
  switch (object) {
    case FightSportPayload.FIGHT_SPORT_UNKNOWN:
      return "FIGHT_SPORT_UNKNOWN";
    case FightSportPayload.AMATEUR_BOXING:
      return "AMATEUR_BOXING";
    case FightSportPayload.IMMAF_MMA:
      return "IMMAF_MMA";
    case FightSportPayload.MUAY_THAI_KICKBOXING:
      return "MUAY_THAI_KICKBOXING";
    case FightSportPayload.PRO_MMA:
      return "PRO_MMA";
    case FightSportPayload.CHICKEN_FIGHT:
      return "CHICKEN_FIGHT";
    case FightSportPayload.MUAY_THAI_KICKBOXING_NO_FACE:
      return "MUAY_THAI_KICKBOXING_NO_FACE";
    case FightSportPayload.NO_GI_JIU_JITSU:
      return "NO_GI_JIU_JITSU";
    case FightSportPayload.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}
